/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {NgModule} from '@angular/core';
// import {PmdCommonModule} from '@angular/material/core';
import {
  PmdCard,
  PmdCardAvatar,
  PmdCardBody,
  PmdCardHeader,
  PmdCardFooter,	
  PmdCardImage,
  PmdCardSubtitle,
  PmdCardText,
  PmdCardTitle,
  PmdCardHeaderMedia,
  pmdMediaList,	
} from './card';


@NgModule({
  imports: [],
  exports: [
    PmdCard,
    PmdCardHeader,
    PmdCardHeaderMedia,
	  PmdCardBody,  
    PmdCardTitle,
	  PmdCardText,  
    PmdCardSubtitle,
    PmdCardFooter,
    PmdCardImage,
    PmdCardAvatar,
	  pmdMediaList,  
  ],
  declarations: [
    PmdCard, PmdCardHeader, PmdCardHeaderMedia, PmdCardBody, PmdCardTitle, PmdCardText, PmdCardSubtitle, PmdCardFooter, PmdCardImage, PmdCardAvatar, pmdMediaList,
  ],
})
export class PmdCardModule {}
